<template>
  <div class="fm-register container">
    <el-card shaow="never">
      <el-tabs class="register-tabs" v-model="activeName" @tab-click="handleClick">
        <!--        <el-tab-pane label="账号注册" name="first">-->
        <!--          <register-form @register="registered" />-->
        <!--        </el-tab-pane>-->
        <el-tab-pane label="手机注册" name="second">
          <register-by-phone-form @register="registered" />
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <el-dialog
      title="注册成功"
      :visible.sync="dialogVisible"
      width="300px"
      :close-on-click-modal="false"
      center
      :showClose="false"
    >
      <div style="text-align:center;line-height:2em;">
        <p >
          <span v-if="approval" style="color:#14b14e">申请已提交,请等待审批</span>
          <span v-else style="color:#14b14e">注册成功,请前往首页登录</span>
        </p>
        <p>
          <el-link style="color:#409EFF" @click="$router.push('/')">去首页</el-link>
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import registerForm from "./register-form";
import registerByPhoneForm from "./register-form-phone";

export default {
  components: {
    // registerForm,
    registerByPhoneForm
  },
  data() {
    return {
      // 是否需要等待审批
      approval: true,
      dialogVisible: false,
      activeName: "second"
    };
  },
  methods: {
    registered(waitApproval) {
      this.approval = waitApproval;
      this.dialogVisible = true;
    },
    handleClick() {
      // do something
    }
  }
};
</script>

<style lang="less">
.fm-register {
  .register-tabs {
    .el-tabs__content {
      margin-top: 2em;
    }
  }
}
</style>

<style lang="less" scoped>
.fm-register {
  margin-top: 2em;
  max-width: 600px;
  //.register-tabs {}
  .fm-register-title {
    text-align: center;
    margin-bottom: 15px;
  }
}
</style>
